import React from 'react';
import { UserProfileContainer } from 'components/userProfile/UserProfileContainer';
import { GlobalNavigation, Grid, GridItem, PageLoading, SpaceWrapper } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { OrderHeaderContainer } from './header/OrderHeaderContainer';
import { Copyright } from 'ui-toolkit/components/Copyright/Copyright';
import type { FCWithChildren } from '../../types/FCWithChildren';

export interface IOrderLayoutProps {
  fetchStatus: IFetchStatus;
}

export const OrderLayout: FCWithChildren<IOrderLayoutProps> = ({ children, fetchStatus }) => {
  return (
    <div className={'flex min-h-screen flex-col'}>
      <PageLoading isLoading={fetchStatus.fetching} />
      <GlobalNavigation active={`Orders`} isLogoLink profile={<UserProfileContainer />} />
      <SpaceWrapper topSpace={'default'}>
        <Grid>
          <GridItem>
            <OrderHeaderContainer />
          </GridItem>
          {children}
        </Grid>
      </SpaceWrapper>
      <Copyright className={'mt-auto'} />
    </div>
  );
};
